import { Button, Radio, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { addSurveyResult } from "../../../api/survey/addsurveyresult";
import { getSurveyQue } from "../../../api/survey/getSurveyQue";
import { SurveyContext } from "../../../store/surveyStore";
import Modal from "antd/lib/modal/Modal";

export default function SurveyQues() {
  const history = useHistory();
  const { surveyC, dispatchSurvey } = SurveyContext();
  const [userAns, setUserAns] = useState([]);

  const { id } = useParams();

  const surveyQue = surveyC.surveyQue ? surveyC.surveyQue : null;
  const answeredQues = surveyC.answeredQues ? surveyC.answeredQues : null;
  const [surveyStartModal, setSurveyStartModal] = useState(!!surveyQue);
  const [surveyEndModal, setSurveyEndModal] = useState(false);

  console.log(surveyQue);

  useEffect(() => {
    setSurveyStartModal(!!surveyQue);
  }, [surveyQue]);

  useEffect(() => {
    getSurveyQue(id, dispatchSurvey);
  }, []);

  const handleSurveyAns = (e, surveyQue) => {
    const answer = e.target.value;
    const que_id = surveyQue.id;

    let ans = userAns;

    const ansIndex = ans.findIndex((ansData) => ansData.que_id === que_id);

    if (ans.length > 0 && ansIndex !== -1) {
      console.log("run if condition");
      ans.splice(ansIndex, 1, { answer, que_id });
    } else {
      console.log("run else condition");
      ans = [...ans, { answer, que_id }];
    }
    setUserAns(ans);
  };

  useEffect(() => {
    console.log(userAns);
  }, [userAns]);

  const handleAddSurvey = () => {
    setSurveyEndModal(false);
    addSurveyResult(id, userAns, dispatchSurvey, history);
    // getSurveyQue(id, dispatchSurvey);
  };

  return (
    <>
      <Modal
        width={786}
        style={{ top: "20px" }}
        visible={surveyStartModal}
        className="sml-modal survey-start-modal"
        footer={
          <div className="sml-footer">
            <button
              className="custom-btn"
              onClick={() => setSurveyStartModal(false)}
            >
              Continue
            </button>
          </div>
        }
        onCancel={() => setSurveyStartModal(false)}
      >
        <p
          dangerouslySetInnerHTML={{
            __html: surveyQue ? surveyQue.survey_prop.intro_msg : "",
          }}
        ></p>
      </Modal>

      {surveyQue && surveyQue.survey_que && (
        <div className="survey-ques-page">
          <h2>{surveyC.surveyName}</h2>
          <div className="survey-questions">
            {surveyQue &&
              surveyQue.survey_que.map((surveyQue, index) => {
                return (
                  <div className="survey-ques" key={index}>
                    <div className="survey-ques__que">
                      <span className="ques-number">Q.{index + 1}</span>
                      <div className="survey-main-ques">
                        <p>{surveyQue.que_title}</p>
                        <Radio.Group
                          onChange={(e) => handleSurveyAns(e, surveyQue)}
                        >
                          {surveyQue.choices.map((choice, index) => {
                            return (
                              <Radio.Button value={choice} key={index}>
                                {choice}
                              </Radio.Button>
                            );
                          })}
                        </Radio.Group>
                      </div>
                    </div>
                  </div>
                );
              })}

            <div className="survey-que-btn">
              <Tooltip
                title={
                  surveyQue &&
                  surveyQue.survey_que.length !== userAns.length &&
                  "Please answer all the question"
                }
              >
                <button
                  className="custom-btn survey"
                  onClick={() =>
                    surveyQue && surveyQue.survey_que.length === userAns.length
                      ? setSurveyEndModal(true)
                      : undefined
                  }
                >
                  Continue
                </button>
              </Tooltip>
            </div>
          </div>
        </div>
      )}

      <Modal
        className="sml-modal"
        visible={surveyEndModal}
        footer={
          <div className="sml-footer">
            <button className="custom-btn" onClick={handleAddSurvey}>
              {/* Finish */}
              OK
            </button>
          </div>
        }
        onCancel={() => setSurveyEndModal(false)}
      >
        <h2
          style={{ textAlign: "center" }}
          dangerouslySetInnerHTML={{
            __html: surveyQue ? surveyQue.survey_prop.end_msg : "",
          }}
        ></h2>
      </Modal>

      {answeredQues && (
        <div className="survey-ques-page">
          <div className="survey-questions">
            {answeredQues &&
              answeredQues.map((answeredQues, index) => {
                return (
                  <div className="survey-ques" key={index}>
                    <p>
                      {index + 1}. {answeredQues.que_title}
                    </p>
                    <h3>Ans. {answeredQues.answer}</h3>
                  </div>
                );
              })}
          </div>
        </div>
      )}
    </>
  );
}
